import { render, staticRenderFns } from "./svgIcon.vue?vue&type=template&id=6d8f8de2&scoped=true"
import script from "./svgIcon.vue?vue&type=script&lang=js"
export * from "./svgIcon.vue?vue&type=script&lang=js"
import style0 from "./svgIcon.vue?vue&type=style&index=0&id=6d8f8de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f8de2",
  null
  
)

export default component.exports